module.exports = __webpack_public_path__ + "static/media/classroom2.b1421595.png";